import { calcSpacing } from 'src/components/foundations';
import { ErrorMessage } from 'src/components/atoms/FormErrorMessage';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SectionContainer = styled.div`
  margin-bottom: ${calcSpacing(2.5)}px;
  width: 100%;
`;

export const TitleDescriptionCard = styled.div<{ $isCollapsed?: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: ${({ $isCollapsed }) =>
    $isCollapsed ? '12px 24px' : '12px 24px 24px'};
  gap: 16px;
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  border: 1px solid #e6e6e6;
  border-radius: 12px;
`;

export const CardContentWrapper = styled.div<{ isCollapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ isCollapsed }) => (isCollapsed ? '0' : `${calcSpacing(3.2)}px`)};
  width: 100%;
  cursor: ${({ isCollapsed }) => (isCollapsed ? 'pointer' : 'default')};
  user-select: ${({ isCollapsed }) => (isCollapsed ? 'none' : 'auto')};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
  cursor: pointer;
  user-select: none;
`;

export const SectionTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH4)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  letter-spacing: 0.2px;
`;

export const CollapseIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    cursor: pointer;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const FieldLabelRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  min-height: 16px;
`;

export const FormLabel = styled.label`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.caption.fontFamily};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  height: 16px;
  letter-spacing: 0.3px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  margin: 0;
`;

export const RequiredMark = styled.span`
  font-weight: 400;
`;

export const CKEditorContainer = styled.div`
  .ck-editor__editable {
    min-height: 130px;
    font-family: ${(props) =>
      props.theme.atlas.typography.semantic.body.fontFamily};
    font-size: 14px;
    line-height: 24px;
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
  }

  &.ck-editor-error .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
  &.ck-editor-error .ck.ck-editor__main > .ck-editor__editable {
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.action.destructive.hover} !important;
  }
`;

export const FieldWrapper = styled.div`
  position: relative;
  width: 100%;

  input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`;

export const CharacterCounter = styled.span<{ isError?: boolean }>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.caption.fontFamily};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-feature-settings:
    'tnum' on,
    'lnum' on;
  letter-spacing: 0.3px;
  flex-shrink: 0;
  color: ${(props) =>
    props.isError
      ? props.theme.atlas.semantic.color.status.error.text
      : props.theme.atlas.semantic.color.type.muted};
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: ${calcSpacing(0.8)}px;
`;

export const LoadingStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${calcSpacing(10)}px 0;
  width: 100%;
`;

export const MinimalCardContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;
`;
